import { render } from "./AccountSettingPassword.vue?vue&type=template&id=7ac88c6a"
import script from "./AccountSettingPassword.vue?vue&type=script&lang=js"
export * from "./AccountSettingPassword.vue?vue&type=script&lang=js"
script.render = render

export default script